import { ArrowRight } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';
import { ASSETS } from '@/assets';

const ImageTile = ({ src, item, span }) => (
  <div className={`relative overflow-hidden rounded-3xl border-2 border-brand-green/10 group min-h-64 ${span}`}>
    <img
      src={src}
      alt={item.title}
      className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
      loading="lazy"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-brand-green/85 via-brand-green/20 to-transparent" />
    <div className="absolute bottom-0 left-0 right-0 p-6">
      <h4 className="font-display text-2xl uppercase text-brand-cream">{item.title}</h4>
      <p className="text-xs font-medium text-brand-cream/80 mt-1 max-w-xs">{item.desc}</p>
    </div>
  </div>
);

export const Surfaces = () => {
  const { t } = useLanguage();
  const items = t.surfaces.items;
  return (
    <section id="surfaces" className="py-24 px-4 sm:px-6 lg:px-8 bg-[#F2E8D5]/70 border-y-2 border-brand-green/10">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div className="space-y-3">
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-brand-orange">{t.surfaces.overline}</p>
            <h2 className="font-display text-5xl md:text-7xl uppercase leading-[0.9] tracking-tight text-brand-green">{t.surfaces.title}</h2>
            <p className="text-base md:text-lg font-medium text-brand-green/80">{t.surfaces.subtitle}</p>
          </div>
          <a href="#product" data-testid="surfaces-order-link" className="inline-flex items-center gap-1.5 text-sm font-extrabold uppercase tracking-wider text-brand-orange hover:gap-3 transition-all">
            {t.surfaces.link} <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
          <div className="md:col-span-2 md:row-span-2 bg-brand-green text-brand-cream rounded-3xl p-8 flex flex-col justify-between min-h-72">
            <p className="font-display text-3xl md:text-4xl uppercase leading-[0.95]">{t.surfaces.tileMain}</p>
            <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-brand-cream/70">{t.surfaces.tileList}</p>
          </div>
          <ImageTile src={ASSETS.petsTrio} item={items[0]} span="md:col-span-4 min-h-72" />
          <ImageTile src={ASSETS.catStudio} item={items[1]} span="md:col-span-2" />
          <ImageTile src={ASSETS.petsCorgi} item={items[2]} span="md:col-span-2" />
          <ImageTile src={ASSETS.dogLabrador} item={items[3]} span="md:col-span-3 min-h-72" />
          <a
            href="#product"
            data-testid="surfaces-cta-tile"
            className="md:col-span-3 bg-brand-orange text-white rounded-3xl p-8 flex items-center justify-between gap-4 min-h-72 hover:bg-[#C75007] transition-colors group"
          >
            <p className="font-display text-3xl md:text-4xl uppercase leading-[0.95]">{t.surfaces.tileList}</p>
            <ArrowRight className="w-8 h-8 shrink-0 group-hover:translate-x-2 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
};
